<template>
  <div>
    <entry-list />
    <archive-list />
  </div>
</template>
<script>
import archiveList from '../components/archiveList'
import entryList from '../components/entryList'
export default {
  components: {
    archiveList,
    entryList
  }
}
</script>
